<!--
 * @Author: 李明明
 * @Date: 2022-08-22 10:22:37
 * @LastEditTime: 2022-11-18 14:22:43
 * @LastEditors: 李明明
 * @Description: 消息通知
 * @FilePath: /ykt-micro-main/src/components/public/notice.vue
 * 代码版权方：'政府采购信息网'
-->
<template>
  <div class="notice_wrap" v-if="noticeShow">
    <p class="notice_title" @click="GoNoticeCenter">
      {{noticeData.title}}
    </p>
    <p class="notice_info" @click="GoNoticeCenter">详情</p>
    <i class="iconfont iconyiliaohangyedeICON- close" @click="noticeShow=false"></i>
  </div>
</template>

<script setup>
  import {ref} from 'vue'
  import {useRouter} from 'vue-router';

  const router = useRouter();

  const props = defineProps({
    noticeData: Object
  })
  const noticeShow = ref(true)

  const GoNoticeCenter = ()=>{
    router.push({
      path: '/message/info',
      query: {
        id: props.noticeData.id
      }
    })
  }
</script>
<style lang="scss" scoped>
// @import url(); 引入公共css类
.notice_wrap{
  margin: 20px 0 10px 0;
  height: 60px;
	background-color: rgb(222,236,247);
	border-radius: 9px;
  font-size: 16px;
  line-height: 60px;
}
.notice_title{
  margin: 0 16px 0 20px;
  max-width: 870px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  font-size: 16px;
  color: #d30a14;
  cursor: pointer;
  &:hover{
    opacity: .4;
  }
}
.notice_info{
  display: inline-block;
  vertical-align: middle;
  letter-spacing: 1px;
	color: #418ec6;
  line-height: 16px;
  cursor: pointer;
  font-size: 16px;
  border-bottom: 1px solid #418ec6;
  &:hover{
    opacity: .4;
  }
}
  .close{
    float: right;
    margin-right: 18px;
    cursor: pointer;
    &:hover{
      opacity: .4;
    }
  }
</style>
